import { HarvestPagination } from '../model/harvest_pagination';
import { FetchHarvestRepository } from '../../data/repository/fetch_harvest_repository';
import { Pagination } from "@/core/domain/model/pagination";
import { DataOptions } from "vuetify";
import { en } from '../model/harvest';

export interface FetchHarvestUseCase {
    (pagination: DataOptions, search: string): Promise<HarvestPagination>
}

const fetchHarvestUseCase = (repository: FetchHarvestRepository): FetchHarvestUseCase => async (pagination: DataOptions, search: string) => {
    try {
        const payload: Pagination = {
            sort: pagination.sortBy.map((s: string) => en[s]).join(','),
            descending: pagination.sortDesc.join(','),
            page: pagination.page,
            itemsPerPage: pagination.itemsPerPage,
            search: search
        }
        return await repository(payload);
    } catch (error) {
        throw error
    }
}

export default fetchHarvestUseCase;